import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { placeholderMembersApi } from 'src/Services/API';
import { CreatePlaceholderMemberDto, PlaceholderMemberDto } from 'src/Services/API/generated';
import { trackPlaceholderMemberCreated } from 'src/Services/Mixpanel/events';
import { ApiError } from 'src/types/api-error.types';

export const useCreatePlaceholderMember = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<PlaceholderMemberDto, AxiosError<ApiError>, CreatePlaceholderMemberDto>({
    mutationFn: async dto => {
      if (!assetId) throw new Error('assetId is required to create a placeholder member');
      return (await placeholderMembersApi.placeholderMembersControllerCreate(assetId, dto)).data;
    },
    onSuccess: (_data, dto) => {
      trackPlaceholderMemberCreated({
        asset_id: assetId ?? '',
        ownership_nature: dto.ownershipNature,
        has_estimated_email: !!dto.estimatedEmail,
      });
      queryClient.invalidateQueries(['fetch-members', assetId]);
      queryClient.invalidateQueries(['fetch-asset-details', assetId]);
      queryClient.invalidateQueries(['fetch-households', assetId]);
    },
  });
};
